const isLocalDev = window.location.hostname === "localhost" && window.location.port === "5222";
const isProd = window.location.hostname !== "localhost";

const appsettings = isLocalDev
  ? {
      // DEV settings (npm start on port 5222)
      loraMessageEndpoint: "http://localhost:4001",
      signalRServer: "https://localhost:5222/signalRHub",
      serverBaseUrl: "http://localhost:5050",
    }
  : isProd
  ? {
      // PROD settings (dspx.eu)
      loraMessageEndpoint: "http://dspx.eu:1884",
      signalRServer: "http://dspx.eu/signalRHub",
      serverBaseUrl: "https://dspx.eu",
    }
  : {
      // Docker local (localhost:8080 or any other local port)
      loraMessageEndpoint: "http://localhost:4001",
      signalRServer: `${window.location.origin}/signalRHub`,
      serverBaseUrl: window.location.origin,
    };

export default appsettings;